module.exports = __webpack_public_path__ + "static/media/trave mall shot 5 high res dayyy.ba3a6485.webp";